'use strict';

(() => {
    const input = document.querySelector('header .search__input.field__input');
    const activeClass = 'focus--empty';
    
    const updateClass = () => {
        if (document.activeElement === input && input.value.trim() === '') {
            input.classList.add(activeClass);
        } else {
            input.classList.remove(activeClass);
        }
    }
      
    input.addEventListener('focus', updateClass);
    input.addEventListener('input', updateClass);
    input.addEventListener('blur', () => {
        setTimeout(() => {
            input.classList.remove(activeClass);
        }, 100);
    });
    

    document.addEventListener('resultsupdated', () => {
        const searchItemHeadings = document.querySelectorAll('.predictive-search__articles-wrapper .predictive-search__item-heading, .predictive-search__recipes-wrapper .predictive-search__item-heading');

        searchItemHeadings.forEach((header) => {
            if(header.scrollHeight > 20) {
                const targetDescription = header.parentElement.querySelector('.predictive-search__item-description');
    
                if(targetDescription) {
                    targetDescription.style.setProperty('-webkit-line-clamp', '1');
                }
            }
        });

        const categoryButtons = document.querySelectorAll('.predictive-search__result-group__header .predictive-search__result-group__category');
        let counter = 0;

        categoryButtons.forEach((button) => {
            if (button.dataset.listenerMounted === 'true') return;

            if(counter === 0) {
                button.classList.add('active');
                counter = counter + 1;
            }

            button.addEventListener('click', (e) => {
                categoryButtons.forEach((categoryButtons) => {
                    if(categoryButtons.classList.contains('active')) {
                        categoryButtons.classList.remove('active');
                    }
                });

                e.currentTarget.classList.add('active');
            });

            button.dataset.listenerMounted = 'true';
        });
    });
})();
